import styled from '@emotion/styled'
import { colors, measures, font } from 'styles/variables'

const { unit } = measures

const HrComponent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  width: ${({ width = 90 }) => (width == 'full' ? 100 : width)}%;
  margin: ${({ margined = true }) => (margined ? unit : 0)}px 0;

  border-bottom: 1px solid ${({ color = colors.white40 }) => color};

  ::before {
    content: '${({ text }) => text}';

    font-family: ${font.family};
    font-size: ${font.size14};
    font-weight: ${font.weight.light};

    display: inline-block;
    position: absolute;

    background-color: ${colors.white100};

    padding: 0 ${unit}px;
  }
`

export default HrComponent
